export default __webpack_public_path__ + "static/start-stars-bg-89353d177412f4bfa5d747bddfd3afbb.jpg";